import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContainerScroll"] */ "/vercel/path0/src/components/ui/container-scroll-animation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextRevealCardDouble"] */ "/vercel/path0/src/components/ui/text-reveal-card.tsx");
